export default {
    state: {

    },
    mutations: {

    },
    actions: {
        saveNovedad({
            commit
        }, payload) {
            return this.dispatch('save', payload)
        }
    }
}